import { AbstractControl, ValidationErrors } from '@angular/forms'

import { isValidEmail } from '../utils/emails'

/**
 * Angular wrapper around the canonical `isValidEmail` (libs/shared/src/lib/utils/emails.ts),
 * which is the same check the API performs. Use this instead of Angular's built-in
 * `Validators.email`, which is materially looser: a value the form accepts but the API
 * rejects can fail a request after money has already moved.
 *
 * Empty values are left to `Validators.required` so this composes normally.
 */
export function emailValidator(control: AbstractControl): ValidationErrors | null {
  const value = control.value

  if (value == null || value === '') {
    return null
  }

  return isValidEmail(value) ? null : { email: true }
}
